import type { InjectionKey } from "vue";

export const vcScrollbarKey: InjectionKey<VcScrollbarContextType> = Symbol("vc-scrollbar-context");
